// extracted by mini-css-extract-plugin
module.exports = {"reference":"DeliveryStateHistory_reference_IO5EZ","popover":"DeliveryStateHistory_popover_3FuMK","timestamp":"DeliveryStateHistory_timestamp_3ZmeO"};